export const SAVE_SALE_RENT_REPORTING = 'Save the Sale - Rent Reporting';
export const PREQUALMODULE_SUBHEADER =
  'Review offers and lock one in soon to take advantage of these great rates!';
export const PL_MODULE_NAME = 'Personal Loan';
